import React, { useState } from "react";
import Navigationbar from "../layouts/navigationbar";
import Refresh from "../services/refresh";

function RefreshPage() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFail, setShowFail] = useState(false);

  function refreshApi(event) {
    event.preventDefault();
    //console.log("what ami sending:", event);
    return Refresh.sendCommand(event.target.card_no.value)
      .then((res) => {
        if (res === "success") {
          setShowSuccess(true);
          setTimeout(() => setShowSuccess(false), 3000);
        } else {
          setShowFail(true);
          setTimeout(() => setShowFail(false), 3000);
        }
      })
      .catch((err) => alert({ err }));
  }
  return (
    <div>
      <Navigationbar openStatus={false} />
      <div className="w-full p-8 ">
        <form
          className="d-flex flex-column"
          style={{ gap: "10px" }}
          onSubmit={refreshApi}
        >
          <div className="mt-8">
            <label className="block text-gray-700 text-xl font-bold mb-4">
              Картын дугаар
            </label>
            <input
              className="text-gray-700 text-xl border border-gray-300 rounded py-2 px-4 block w-full focus:outline-2 focus:outline-blue-700"
              type="number"
              inputMode="numeric"
              name="card_no"
              required
            />
          </div>
          <div className="mt-8">
            <button
              className="bg-blue-700 text-white font-bold py-2 px-4 w-full rounded hover:bg-blue-600 text-xl"
              type="submit"
            >
              Refresh
            </button>
          </div>
        </form>
        {showSuccess && (
          <div className="mt-8">
            <div
              className="bg-green-400 text-white rounded border-t border-b border-green-500 px-4 py-3"
              role="alert"
            >
              <p className="font-bold text-xl ">SUCCESS /成功/</p>
            </div>
          </div>
        )}
        {showFail && (
          <div className="mt-8">
            <div
              className="bg-red-400 text-white rounded border-t border-b border-red-500 px-4 py-3"
              role="alert"
            >
              <p className="font-bold text-xl ">Amjiltgui /未成功/</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default RefreshPage;
